function togglePDPTabs() {
    const btnToggleArr = Array.from(document.querySelectorAll('.pdp-tabs__tab'));
 
    document.querySelector('.pdp-tabs__tabContent').classList.add('pdp-tabs__tabContent--active');
    document.querySelector('.pdp-tabs__tab').classList.add('pdp-tabs__tab--active');
 
    btnToggleArr.forEach(btn => {
       btn.addEventListener('click', function () {
          document.querySelector('.pdp-tabs__tab--active').classList.remove('pdp-tabs__tab--active');
          btn.classList.add('pdp-tabs__tab--active');
          const tabIndex = btn.dataset.tab;
          document.querySelector('.pdp-tabs__tabContent--active').classList.remove('pdp-tabs__tabContent--active');
          document.querySelector(`.pdp-tabs__tabContent--${tabIndex}`).classList.add('pdp-tabs__tabContent--active');
       });
    });
 }
 
 function charmPopupSlider(classList) {

   const slider = $(classList).find('.charmPopup__carrousel:not(.slick-initialized)');
   
   slider.slick({
          infinite: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          dots: false,
          draggable: true,
          adaptiveHeight: true,
          autoplay: false,
          vertical: true,
          verticalSwiping: true,
          responsive: [
             {
                breakpoint: 767,
                settings: {
                   slidesToShow: 1,
                   slidesToScroll: 1,
                   arrows: false,
                   vertical: false,
                   verticalSwiping: false,
                   dots: true,
                   infinite: false,
                },
             },
          ],
     
    })

    //Implementing navigation of slides using mouse scroll
   slider.on('wheel', function (e) {
      e.preventDefault();
      if (e.originalEvent.deltaY < 0) {
         $(this).slick('slickPrev');
      } else {
         $(this).slick('slickNext');
      }
   });
 }
 
 function toggleCharmPopupVisibility() {
   //  const upsellEl = document.querySelector('.ar-pdp-upsell');
 
   //  upsellEl.addEventListener('click', function (e) {
   //     const btnOpen = e.target.closest('.ar-pdp-upsell__button');
   //     if (!btnOpen) return;
   //     document.querySelector("body").classList.add('no-scroll');
   //     const pageOverlay =  document.querySelector(`.charmPopupGridWrapper`)
   //     const charmPopup = document.querySelector(`.charmPopupGridWrapper[data-popup=${btnOpen.dataset.popup}]`);
   //     const btnClose = charmPopup.querySelector('.charmPopup__btnClose');
   //     charmPopup.classList.add('charmPopup--visible');
   //     charmPopupSlider(`.charmPopupGridWrapper[data-popup=${btnOpen.dataset.popup}]`);
   //     btnClose.addEventListener('click', closePopup);
   //     function closePopup() {
   //        document.querySelector("body").classList.remove('no-scroll')    
   //        charmPopup.classList.remove('charmPopup--visible');
   //     }
   //  });
   const upsellEl = document.querySelector('.ar-pdp-upsell');

   upsellEl.addEventListener('click', function (e) {
      const productImageEl = e.target.closest('.ar-pdp-upsell__media');
      const btnOpen =
         productImageEl?.closest('.product-info').querySelector('.ar-pdp-upsell__button') ||
         e.target.closest('.ar-pdp-upsell__button');

      if (!productImageEl && !btnOpen) return;

      // open popup functionality
      document.querySelector('body').classList.add('no-scroll');
      const charmPopup = document.querySelector(`.charmPopupGridWrapper[data-popup=${btnOpen.dataset.popup}]`);
      const btnClose = charmPopup.querySelector('.charmPopup__btnClose');

      // refresh yotpo widget for popup product
      // window.yotpo && window.yotpo.refreshWidgets()

      charmPopup.classList.add('charmPopup--visible');
      document.querySelector('.klaviyoButton')?.classList.add('klaviyoButton-hide')

      // initialize image slider inside popup
      charmPopupSlider(`.charmPopupGridWrapper[data-popup=${btnOpen.dataset.popup}]`);

      // close popup functionality
      btnClose.addEventListener('click', closePopup);
      charmPopup.addEventListener('click', function (event) {
         if (event.target.classList.contains('charmPopupGridWrapper')) {
            closePopup();
         }
      });

      function closePopup() {
         document.querySelector('body').classList.remove('no-scroll');
         charmPopup.classList.remove('charmPopup--visible');
         document.querySelector('.klaviyoButton')?.classList.remove('klaviyoButton-hide')
      }
   });
 }
 
 $(document).on("click", function(event){
    var $trigger = $(".charmPopup, .ar-pdp-upsell__media, .ar-pdp-upsell__button, .charmPopup__carrousel, .charmPopup__info");
    if($trigger !== event.target && !$trigger.has(event.target).length){
        $(".charmPopupGridWrapper").removeClass('charmPopup--visible');
        document.querySelector("body").classList.remove('no-scroll')    
    }
 });
 
 function toggleAccordion(){
   $('.pdp-accordionContent:first').slideDown().addClass('pdp-accordionContent--active');
   $('.pdp-accordion:first').addClass('pdp-accordion--active');
   $(document).on('click', '.pdp-accordion', function(){
      const accordionIndex = $(this).attr('data-tab');
      $(this).toggleClass('pdp-accordion--active');
      $(this).parents('.accordion-wrapper').siblings('.accordion-wrapper').find('.pdp-accordion--active').removeClass('pdp-accordion--active');
      $(`.pdp-accordionContent.pdp-accordionContent--${accordionIndex}`).slideToggle().toggleClass('pdp-accordionContent--active');
      $(this).parents('.accordion-wrapper').siblings('.accordion-wrapper').find('.pdp-accordionContent').slideUp().removeClass('pdp-accordionContent--active');
   })
}

 function initPDP() {
    //togglePDPTabs();
    toggleAccordion();
    toggleCharmPopupVisibility();
 }
 
 window.addEventListener('DOMContentLoaded', initPDP);
 